'use strict';

var util = angular.module('gymsystem.util');

util.directive('pandemicinfo', ['$rootScope', '$interval', '$location', 'server', 'live', function($rootScope, $interval, $location, server, live) {
    return {
        restrict: 'E',
        templateUrl: 'components/widgets/pandemicinfo/pandemicinfo.html',
        scope: {
            s: '=settings'
        },
        link: function($scope) {
            $scope.settings = {};
            $scope.entries = [];

            var getSettings = function() {
                server.get('/api/settings/pandemicinfo/get').then(function(settings) {
                    $scope.settings = settings;
                });
            };
            getSettings();

            var transformEntry = function(entry) {
                entry.entryTime = Date.newFull(entry.entryTime);
                if (entry.Member) {
                    entry.user_id = entry.Member.id;
                }
            };
            var getEntries = function() {
                var today = Date.today().yyyymmdd();
                server.get('/api/entry/get', { fromDate: today, toDate: today, idOnly: true }).then(function(entries) {
                    angular.forEach(entries, transformEntry);
                    $scope.entries = entries;
                });
            };
            getEntries();

            $scope.getVisitorCount = function() {
                var averageTime = $scope.settings.averageVisitorTime || 60;
                var limit = new Date().addMinutes(-averageTime);
                var visitors = _.filter($scope.entries, function(entry) { return entry.success && entry.entryTime >= limit; });
                return _.uniq(_.pluck(visitors, 'user_id')).length;
            };

            $scope.calculateAreaPerPerson = function() {
                var availableArea = 0;
                if (_.isNumber($scope.settings.area)) {
                    var visitors = $scope.getVisitorCount();
                    availableArea = (visitors > 0) ? ($scope.settings.area / visitors) :  $scope.settings.area;
                    availableArea = +availableArea.toFixed(2); // https://stackoverflow.com/a/12830454
                }
                return availableArea;
            };

            $scope.showGotoSettings = function() {
                return $rootScope.hasPermission('Settings') && !$scope.settings.area;
            };

            $scope.gotoSettings = function() {
                $location.path('/settings/gym');
            };

            live.subscribe({
                type: 'pandemicinfosettings',
                callback: getSettings
            });

            live.subscribe({
                type: 'entry',
                action: 'add',
                callback: function(__, event) {
                    angular.forEach(event.data, function(entry) {
                        transformEntry(entry);
                        $scope.entries.push(entry);
                    });
                }
            });

            $interval(function() {}, 15 * 1000);
        }
    };
}]);
